/** Formatea fecha de auditoría para UI. */
export function formatAuditWhen(iso: string | Date | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString('es-CL', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

/** Etiqueta de rango paginado (ej. 1–50 de 120). */
export function auditRangeLabel(total: number, offset: number, pageSize: number): string {
  if (!total) return '0';
  const from = offset + 1;
  const to = Math.min(offset + pageSize, total);
  return `${from}–${to} de ${total}`;
}

/** Clase de color del badge según tipo de cambio. */
function badgeByAction(action: string | undefined): string | null {
  if (action === 'ROLLBACK') return 'text-secondary';
  if (action === 'APPLY_OPEN') return 'text-warning';
  return null;
}

export function actionBadgeClass(row: any): string {
  const byAction = badgeByAction(row?.action);
  if (byAction) return byAction;
  if (row?.kind === 'CREATED') return 'text-success';
  return 'text-primary';
}

/** Usuario o rol mostrado en la fila. */
export function auditActorLabel(row: any): string {
  if (row?.userName) return row.userName;
  if (row?.roleName) return row.roleName;
  return '—';
}

/** Cambio de pasos (ej. 3 → 5). */
export function stepsChangeLabel(row: any): string {
  const before = row?.stepsBefore ?? '—';
  const after = row?.stepsAfter ?? '—';
  return `${before} → ${after}`;
}

/** Mensaje de éxito tras restaurar una versión. */
export function rollbackSuccessText(applyToOpen: boolean, affectedCount: number): string {
  if (applyToOpen) {
    return `Catálogo restaurado. Snapshot aplicado a ${affectedCount} solicitud(es) abierta(s).`;
  }
  return 'El catálogo del proceso quedó en esa versión.';
}

/** HTML del diálogo de confirmación de rollback. */
export function rollbackConfirmHtml(processLabel: string, whenLabel: string): string {
  return `
    <p class="text-start small mb-2">
      Se reemplazará el flujo actual de
      <b>${processLabel}</b>
      por la versión del
      <b>${whenLabel}</b>.
    </p>
    <ul class="text-start small mb-0">
      <li><b>Solo catálogo</b>: las solicitudes abiertas mantienen su snapshot.</li>
      <li><b>Aplicar a abiertas</b>: también reescribe el snapshot de las abiertas.</li>
    </ul>
  `;
}

/** Opciones del diálogo de confirmación de rollback. */
export function rollbackSwalOptions(html: string) {
  return {
    title: '¿Restaurar esta versión?',
    html,
    icon: 'warning' as const,
    showDenyButton: true,
    showCancelButton: true,
    confirmButtonText: 'Solo catálogo',
    denyButtonText: 'Aplicar a abiertas',
    cancelButtonText: 'Cancelar'
  };
}

/** Opciones del toast de éxito tras rollback. */
export function rollbackSuccessSwalOptions(applyToOpen: boolean, affectedCount: number) {
  return {
    icon: 'success' as const,
    title: 'Versión restaurada',
    text: rollbackSuccessText(applyToOpen, affectedCount),
    timer: 2800,
    showConfirmButton: false
  };
}
